import { render, staticRenderFns } from "./PriceInfo.vue?vue&type=template&id=87983b9c&scoped=true&"
import script from "./PriceInfo.vue?vue&type=script&lang=js&"
export * from "./PriceInfo.vue?vue&type=script&lang=js&"
import style0 from "./PriceInfo.vue?vue&type=style&index=0&id=87983b9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87983b9c",
  null
  
)

export default component.exports